import {
    BingSlotFallbackContainerNames,
    BingSlotAttributionNames,
    BingSlotDivNames,
} from './bing/client-side/ad-slots';

const suppressTextAdSpace = () => {
    // 隐藏 Attribution
    Object.values(BingSlotAttributionNames)
        .map((id) => window.document.getElementById(id))
        .forEach((el) => {
            if (el) el.style.display = 'none';
        });

    // 隐藏广告位内容
    // 因有时取到的是备用位置，所以需要延迟取到真正位置
    let timer = setTimeout(() => {
        Object.values(BingSlotDivNames)
            .map((id) => window.document.getElementById(id))
            .forEach((el) => {
                if (el) {
                    const parent = el.parentElement;
                    if (parent) {
                        // bing-top: 隐藏 display: flex 的包装 div（包含 bing-top 的父元素）
                        // bing-bottom: 隐藏 display: flex 的包装 div（包含 bing-bottom 的父元素，与 bing-top 结构一致）
                        parent.style.display = 'none';
                    }
                }
            });
        clearTimeout(timer);
    }, 50);

    // 显示备用装饰图（bing-top 和 bing-bottom 都有 fallback）
    Object.values(BingSlotFallbackContainerNames)
        .map((id) => window.document.getElementById(id))
        .forEach((el) => {
            if (el) el.style.display = 'block';
        });
};

export default suppressTextAdSpace;
